// extracted by mini-css-extract-plugin
export default {"container":"KO_container__NKq6t","content":"KO_content__XmMsr","title":"KO_title__HdaAD","description":"KO_description__XxWkz","action":"KO_action__SP-IY"};